import React from "react";
import PageLayout from "../UI/PageLayout";
import { GenericReportingDropdowns } from "../../containers/GenericReportingDropdowns";
import ExtraCostSettingsPage from "../../containers/Settings/ExtraCostSettingsPage";

const ExtraCostsSettingsPage = () => {
  return (
    <PageLayout
      title="Extra Costs Settings"
      subTitle="Configure and manage additional cost tracking and management settings"
      dropdowns={
        <GenericReportingDropdowns
          includeDateRange={false}
          includeSingleSelectRegion={true}
          includeGranularity={false}
          includeTooltipsAndTitles={false}
          containerStyle="dropdown-container"
          renderAsButton={true}
          includeCompareDateRange={false}
        />
      }
      content={<ExtraCostSettingsPage />}
    />
  );
};

export default ExtraCostsSettingsPage;
